module.exports = __webpack_public_path__ + "img/outpatientPersonRate.e4b2088b.svg";